import AxiosAPI from '../../../utils/AxiosAPI';

export const handleLoadPaymentsData = (params) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/transaction/`, {
                q: params.q,
                // status: params.status,
                orderby: params['order-by'],
                sort: params.sort,
                page: params.page || 1,
                cpp: params.cpp || 12
            })
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(Error(data.title));
                }
            })
            .catch((error) => {
                reject(error);
            });
    });

export default null;
